(function () {
  function initialize() {
    var roots = document.querySelectorAll('[data-absen-marketing-popup]');

    Array.prototype.forEach.call(roots, function (root) {
      var dialog = root.querySelector('[data-popup-dialog]');
      if (!dialog || root.dataset.initialized === 'true') return;

      root.dataset.initialized = 'true';

      var enabled = root.dataset.enabled === 'true';
      var success = root.dataset.success === 'true';
      var hasError = root.dataset.error === 'true';
      var designMode = root.dataset.designMode === 'true';
      var trigger = root.dataset.trigger || 'delay';
      var delay = Math.max(0, Number(root.dataset.delaySeconds || 0));
      var frequencyDays = Math.max(0, Number(root.dataset.frequencyDays || 0));
      var storageKey = root.dataset.storageKey || 'absen-marketing-popup';
      var timer = null;
      var exitListener = null;
      var closed = false;
      var lastActiveElement = null;

      function isCoolingDown() {
        if (success || hasError || designMode) return false;

        try {
          var lastShown = Number(window.localStorage.getItem(storageKey));
          return Number.isFinite(lastShown) &&
            Date.now() - lastShown < frequencyDays * 86400000;
        } catch (error) {
          return false;
        }
      }

      function recordClose() {
        if (success || designMode || closed) return;
        closed = true;

        try {
          window.localStorage.setItem(storageKey, String(Date.now()));
        } catch (error) {
          // Storage can be unavailable; the popup should still close normally.
        }
      }

      function clearTriggerWork() {
        if (timer !== null) {
          window.clearTimeout(timer);
          timer = null;
        }

        if (exitListener) {
          document.removeEventListener('mouseout', exitListener);
          exitListener = null;
        }
      }

      function anotherDialogIsOpen() {
        return document.querySelector('dialog[open]') !== null || Array.prototype.some.call(
          document.querySelectorAll('[data-absen-marketing-popup]:not([hidden])'),
          function (openPopup) { return openPopup !== root; }
        );
      }

      function show() {
        if ((!enabled && !success && !hasError && !designMode) || !root.hidden || anotherDialogIsOpen() || isCoolingDown()) return;

        closed = false;
        lastActiveElement = document.activeElement;
        clearTriggerWork();
        root.hidden = false;
        document.documentElement.classList.add('absen-marketing-popup-open');

        window.requestAnimationFrame(function () {
          var firstControl = dialog.querySelector('button, input, a[href], [tabindex]:not([tabindex="-1"])');
          (firstControl || dialog).focus();
        });
      }

      function closePopup() {
        if (root.hidden) return;

        root.hidden = true;
        document.documentElement.classList.remove('absen-marketing-popup-open');
        recordClose();
        clearTriggerWork();

        if (lastActiveElement && document.contains(lastActiveElement)) lastActiveElement.focus();
      }

      function scheduleDelay() {
        if (delay === 0) {
          show();
          return;
        }

        timer = window.setTimeout(function () {
          timer = null;
          show();
        }, delay * 1000);
      }

      function setupExitIntent() {
        if (!window.matchMedia || !window.matchMedia('(pointer: fine)').matches) return;

        exitListener = function (event) {
          if (event.relatedTarget === null && event.clientY <= 0) show();
        };
        document.addEventListener('mouseout', exitListener);
      }

      root.addEventListener('click', function (event) {
        if (event.target.closest('[data-popup-close]')) closePopup();
      });

      root.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closePopup();
          return;
        }

        if (event.key !== 'Tab') return;

        var controls = dialog.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])');
        if (!controls.length) return;

        var firstControl = controls[0];
        var lastControl = controls[controls.length - 1];

        if (event.shiftKey && document.activeElement === firstControl) {
          event.preventDefault();
          lastControl.focus();
        } else if (!event.shiftKey && document.activeElement === lastControl) {
          event.preventDefault();
          firstControl.focus();
        }
      });

      if (designMode) {
        document.addEventListener('shopify:section:select', function (event) {
          var section = root.closest('[id^="shopify-section-"]');
          var sectionId = section && section.id.replace('shopify-section-', '');
          if (event.detail && event.detail.sectionId === sectionId) show();
        });
      } else if (enabled && !isCoolingDown()) {
        if (trigger === 'delay' || trigger === 'both') scheduleDelay();
        if (trigger === 'exit' || trigger === 'both') setupExitIntent();
      }

      if (success || hasError) show();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
